import { DateTime } from "luxon";
import { fenceValueWithVat, otherValueWithVat } from "@/utils";
import { pdf_contract, CONTRACT_FORM_CODE } from "@/documents/contract/pdf_contract.js";
import { moduleSizeText, moduleHeightText, moduleNameKey, isPost } from "@/utils/fenceModules";

export default {
  create(contract, executantDetails, firmaMontajContract) {
    return {
      contract,
      executantDetails,
      firmaMontajContract,

      get language() {
        return 'de-DE'
      },

      get isMontajSeparat() {
        return this.contract.detalii.montaj_separat
      },

      get valMasuratori() {
        if (Number(this.contract.masuratori_incluse) === 2) {
          return this.contract.val_masuratori ? Number(this.contract.val_masuratori) * 1.21 : 0
        } else {
          return 0
        }
      },

      get valMontaj() {
        if (Number(this.contract.montaj_inclus) === 2) {
          return this.contract.val_montaj ? Number(this.contract.val_montaj) * 1.21 : 0
        } else {
          return 0
        }
      },

      get valTransport() {
        if (Number(this.contract.transport_inclus) === 2) {
          return this.contract.val_transport ? Number(this.contract.val_transport) * 1.21 : 0
        } else {
          return 0
        }
      },

      get sumaContract() {
        let val = (fenceValueWithVat(this.contract) + otherValueWithVat(this.contract) + this.valMasuratori + this.valMontaj + this.valTransport)

        if (+this.contract.firma) {
          val = val / 1.21
        }

        return val
      },

      get sumaAvans() {
        return (this.sumaContract * this.contract.c_plata) / 100
      },

      get sumaAvans2() {
        return this.contract.c_plata2 ? (this.sumaContract * this.contract.c_plata2) / 100 : null
      },

      get sumaRest() {
        const avans2 = this.sumaAvans2 || 0
        return this.sumaContract - this.sumaAvans - avans2
      },

      get executantFirmaText() {
        return `1. CUPROLLI MANUFACTURING SRL, mit Geschäftssitz in CAPRIOAREI Straße, Nr. 11, GHIRODA, Landkreis Timis, Postleitzahl 307200, Rumänien, eingetragen im Handelsregister unter der Nr. J2016000468359, mit der Steuernummer RO 35671874, IBAN: RO89 BTRL EURC RT03 3757 8301, BIC: BTRLRO22, Bankname: Banca Transilvania nachfolgend iSTRUCT bezeichnet, vertreten von Octavian Rosu, als Geschäftsführer.`
      },

      // get montajFirmaText() {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. ${this.firmaMontajContract.denumire_firma.toUpperCase()} S.R.L., cu sediul in ${this.firmaMontajContract.adresa} inregistrata in Registrul Comertului sub numarul ${this.firmaMontajContract.regcom}, mit der Steuernummer ${this.firmaMontajContract.cui} (${Number(this.firmaMontajContract.vat) ? "platitor" : "neplatitor"} de TVA), cont bancar: ${this.firmaMontajContract.bank_account}, ${this.firmaMontajContract.bank}, reprezentata legal prin ${this.firmaMontajContract.person}, in calitate de MONTATOR`
      // },

      // get montajFirma1Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI DESIGN S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022003676350, cod fiscal 46619944 (neplatitor de TVA), cont bancar: RO74BTRLRONCRT0CH8981101, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      // get montajFirma2Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI PARTENER S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022005419357, cod fiscal 47219300 (neplatitor de TVA), cont bancar: RO14BTRLRONCRT0664679101, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      // get montajFirma3Text()  {
      //   if (!this.firmaMontajContract) return ''
      //   return `2. S.C. CUPROLLI PROIECTE S.R.L., cu sediul in Ghiroda, Str. Caprioarei nr. 11, Jud. Timis, inregistrata in Registrul Comertului sub numarul J2022004612351, cod fiscal 46926167 (neplatitor de TVA), cont bancar: RO11BTRLRONCRT0661673901, Banca Transilvania, reprezentata legal prin Rosu Octavian, in calitate de MONTATOR`;
      // },

      get actClient() {
        if (this.contract.detalii.alt_document) {
          return this.contract.detalii.alt_document + ' Nr. ' + this.contract.detalii.alt_document_nr
        }
        return `C.I. serie ${this.contract.detalii.serie_ci} nr. ${this.contract.detalii.numar_ci}`
      },

      get adresaClient() {
        if (this.contract.persoana) {
          return `mit Geschäftssitz in ${this.contract.adresa}`
        } else {
          return `wohnhaft in ${this.contract.detalii.adresa}`
        }
      },

      get contactClient() {
        const tel = String(this.contract.tel || "").trim()
        const email = String(this.contract.email || "").trim()
        return [
          tel ? `Telefon: ${tel}` : null,
          email ? `E-Mail: ${email}` : null
        ].filter(Boolean)
      },

      get moduleGard() {
        return this.contract.gard_obj.map(modul => ({
          type: "listItem",
          content: [{
            type: "paragraph",
            attrs: { textAlign: "left" },
            content: [{
              type: "text",
              // a post has no width, so it is quoted by height alone
              text: isPost(modul.tip)
                ? `${this.denumireModulGard(modul)} - H ${moduleHeightText(modul)} mm - ${modul.buc} Stück`
                : `${this.denumireModulGard(modul)} - mit den Maßen L x H ${moduleSizeText(modul)} mm - ${modul.buc} Stück`
            }]
          }]
        }))
      },

      get moduleCustom() {
        if (!this.contract.alte_obj) return []
        return this.contract.alte_obj.map(modul => ({
          type: "listItem",
          content: [{
            type: "paragraph",
            attrs: { textAlign: "left" },
            content: [{
              type: "text",
              text: `${this.getTranslatedName(modul.denumire)} - ${modul.cantitate} Stück`
            }]
          }]
        }))
      },

      get vatText() {
        return +this.contract.firma ? "ohne MwSt." : "inkl. MwSt."
      },

      get price() {
        return `Der Gesamtpreis für die Produkte und gegebenenfalls für zusätzliche Dienstleistungen beträgt ${this.sumaContract.toFixed(2)} Euro (${this.vatText}) und ergibt sich aus dem Angebot Nr. ${this.contract.oferta_id} vom ${DateTime.fromISO(String(this.contract.oferta_data)).toFormat("dd.MM.yyyy")}.`
      },

      get payment1() {
        return `Der Kunde verpflichtet sich, iSTRUCT innerhalb von 5 Arbeitstagen nach Unterzeichnung dieses Vertrags (oder ggf. nach Ausstellung der Proforma-Rechnung) eine Anzahlung in Höhe von ${this.sumaAvans.toFixed(2)} Euro (${this.vatText}) des vereinbarten Gesamtpreises zu zahlen.`
      },

      get payment2() {
        return `Die Restzahlung in Höhe von ${this.sumaRest.toFixed(2)} Euro (${this.vatText}) wird innerhalb von 3 Arbeitstagen ab dem Datum der Fertigstellung der Arbeiten und der Unterzeichnung des Abnahmeprotokolls der Produkte/Gewerke oder gemäß der von iSTRUCT ausgestellten Rechnung gezahlt.`
      },

      get p1TermenExecutie() {
        if (this.contract.detalii.finisaj_finalizat) {
          return `Conform informatiei furnizare de catre beneficiar la data intocmirii acestui contract, partea de lucrare ce cade in sarcina sa, si anume, partea de zidarie, beton, stalpi de metal, etc., pe care se vor prinde reperele din aluminiu ce vor fi confectionate de executant, este complet finisata si se pot face masuratorile finale. In acest caz termenul de executie al acestor repere este de ${this.contract.t_executie} zile de la data creditarii contului beneficiarului cu suma stabilita la art VI.`
        } else {
          return `Avand in vedere ca, la data intocmirii acestui contract, beneficiarul nu are finalizata partea de lucrare ce cade in sarcina sa, si anume, partea de zidarie, beton, stalpi de metal, etc., pe care se vor prinde reperele din aluminiu ce vor fi confectionate de executant, termenul de executie a acestor repere este de ${this.contract.t_executie} zile de la data in care executantul va putea sa faca masuratorile finale.`
        }
      },

      get p2TermenExecutie() {
        if (this.contract.detalii.finisaj_finalizat) {
          return `Daca in momentul deplasarii pentru efectuarea masuratorilor, executantul constata ca beneficiarul nu are finalizata partea de lucrare ce cade in sarcina sa, se va intocmi un act aditional in care se va metiona acest lucru iar termenul de executie va fi de ${this.contract.t_executie} zile de la data in care se vor putea face masuratorile finale.`
        } else {
          return `In acest sens se va intocmi un act aditional la contract in care se va mentiona faptul ca beneficiarul are finalizata partea de lucrare ce cade in sarcina sa si executantul poate lua masuratorile finale.`
        }
      },

      get exemplareContract() {
        return this.isMontajSeparat ? "3 (trei)" : "2 (doua)"
      },

      // Helper methods
      // What a module is called in this contract, keyed by type and variant. Adding a type is a
      // key here and a line in moduleNameKey - never another branch below.
      moduleNames: {
        panel: "Zaunfeld",
        pedestrianGate: "Gartentor",
        pedestrianGateSidePanel: "Gartentor mit Seitenpaneel",
        swingGateSingleLeaf: "Einflügeltor",
        swingGateDoubleLeaf: "Zweiflügeltor",
        swingGateBiFoldSingle: "Einflügeliges Falttor",
        swingGateBiFoldDouble: "Zweiflügeliges Falttor",
        slidingGateSingleLeaf: "Schiebetor",
        slidingGateDoubleLeaf: "Doppelschiebetor",
        slidingGateTelescopic: "Teleskopschiebetor",
        slidingGateArticulated: "Eckschiebetor (90° Winkel)",
        selfSupportingGate: "freitragende Schiebetor",
        posts: "Pfosten",
        post80: "Pfosten 80 × 80 mm",
        post100: "Pfosten 100 × 100 mm",
        post200: "Pfosten 200 × 100 mm",
        framedPanel: "Gerahmte Zaunpaneele"
      },

      denumireModulGard(modul) {
        const key = moduleNameKey(modul.tip, modul.tip_poarta_mare, modul.tip_stalp)
        // a type with no key only ever comes from an offer saved with something since retired
        let name = (key && this.moduleNames[key]) || String(modul.tip || "").replace(/_/g, " ")
        if (modul.pp_included) name += " mit integriertem Fußgängertor"
        return name
      },

      getTranslatedName(name) {
        let newName = name
        if (name == 'Kit automatizare premium poarta culisanta - BFT Deimos Ultra') {
            newName = 'Premium-Schiebetor-Automatisierungskit - BFT Deimos Ultra'
        }
        if (name == 'Kit automatizare premium poarta culisanta - BFT Ares Veloce') {
            newName = 'Premium-Schiebetor-Automatisierungskit - BFT Ares Veloce'
        }
        if (name == 'Kit automatizare premium poarta batanta - BFT Kustos Ultra A40') {
            newName = 'Premium-Zweiflügeltor-Automatisierungskit - BFT Kustos Ultra A40'
        }
        if (name == 'Kit automatizare premium poarta batanta - BFT Virgo') {
            newName = 'Premium-Zweiflügeltor-Automatisierungskit - BFT Virgo'
        }
        return newName
      },

      formatParagraph(textContent, alignment, textType) {
        return {
          type: "paragraph",
          attrs: { textAlign: alignment },
          content: [{
            type: "text",
            text: textContent,
            ...(textType && { marks: [{ type: textType }] })
          }]
        }
      },

      // Main document structure builder
      buildDocumentStructure() {
        return {
          type: "doc",
          content: [
            // Header
            {
              type: "heading",
              attrs: { textAlign: "left", level: 1 },
              content: [{ type: "text", text: "KOOPERATIONSVEREINBARUNG" }]
            },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 3 },
              content: [{type: "text", text: "über den Verkauf von Zäunen, Toren und anderem Zubehör sowie die Erbringung von Montage- und anderen damit verbundenen Dienstleistungen"}]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `Abgeschlossen heute, ${DateTime.fromISO(String(this.contract.data)).toFormat("dd.MM.yyyy")}, in Ghiroda.`
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },

            // I. CONTRACT PARTIES
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "I. VERTRAGSPARTEIEN" }]
            },
            this.formatParagraph(this.executantFirmaText, "left"),
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `2. ${this.contract.nume.toUpperCase()}, ${[this.adresaClient, ...this.contactClient].join(", ")}, ausgewiesen mit ${this.actClient} nachfolgend Kunde bezeichnet.`
              }]
            },
            { type: "blockquote"},            
            { 
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `Die Parteien vereinbaren nachstehende Klauseln:`
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            // II. CONTRACT OBJECT
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "1. VERTRAGSGEGENSTAND" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "1.1. Gegenstand dieses Vertrages ist die Lieferung der Produkte (Tore, Zäune, Aluminiumzubehör, Automatisierungen und andere Komponenten) durch iSTRUCT und deren Installation/Montage am Standort des Kunden gemäß den vom Kunden vorgelegten und von iSTRUCT akzeptierten Spezifikationen und Anforderungen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "1.2. Zur Erfüllung des Vertragsgegenstandes kann iSTRUCT mit zugelassenen Partnern zusammenarbeiten, die gemäß den technischen Anweisungen von iSTRUCT Montage-, Handhabungs- und Transportleistungen erbringen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `1.3. Beschreibung der Arbeit`
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `Die einzelnen Bestandteile der Leistung sind wie folgt:`
              }]
            },
            { type: "bulletList", content: this.moduleGard },
            { type: "bulletList", content: this.moduleCustom },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `Alle Elemente werden gemäß der Farbvorgabe des Auftraggebers in ${this.contract.color} pulverbeschichtet.`
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            // III. CONTRACT DURATION
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "2. PFLICHTEN DER PARTEIEN" }]
            },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 3 },
              content: [{ type: "text", text: "2.1. Pflichten von iSTRUCT" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "2.1.1. Lieferung der Produkte: iSTRUCT verpflichtet sich, die Produkte gemäß den Qualitätsstandards und den mit dem Kunden vereinbarten Spezifikationen zu liefern, wie sie im kommerziellen Angebot (Anhang/Angebot) aufgeführt sind und dabei die einvernehmlich vereinbarten Lieferbedingungen einzuhalten."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `2.1.2. Sicherstellung der Konformität und Gewährleistung:`
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "iSTRUCT gewährt eine Garantie von 5 (fünf) Jahren auf die Pulverbeschichtung der Aluminiumprodukte, beginnend mit dem Datum der Abnahme durch den Kunden, unter den im Garantieschein und/oder anderen Vertragsdokumenten aufgeführten Bedingungen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "iSTRUCT gewährt für die Automatisierungssysteme und das elektronische Zubehör eine Garantie von 2 (zwei) Jahren ab dem Datum der Abnahme durch den Kunden gemäß den geltenden gesetzlichen Bestimmungen und den im entsprechenden Garantieschein festgelegten Bedingungen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Die Garantieklauseln werden durch die geltenden gesetzlichen Bestimmungen über den Verbraucherschutz und den Verkauf von Produkten ergänzt. Im Falle von Mängeln während der Garantiezeit ist iSTRUCT verpflichtet, das Produkt zu reparieren, zu ersetzen oder den Kaufpreis zu erstatten, je nach den gesetzlichen Bestimmungen und der internen Garantiepolitik."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `2.1.3. Fotos für Qualitätssicherung und kommerzielle Zwecke`
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "iSTRUCT behält sich das Recht vor, zu Zwecken der Qualitätssicherung und der technischen Dokumentation (u.a. zum Nachweis der Konformität der Montage) während und nach Abschluss der Arbeiten Fotos anzufordern."
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Unabhängig davon kann iSTRUCT die ausdrückliche Zustimmung des Kunden zur Verwendung von Fotos der installierten Produkte in Werbematerialien, Online-/Offline- Portfolios oder anderen kommerziellen Zwecken anfordern. Wenn der Kunde zustimmt, verpflichtet sich iSTRUCT zur Wahrung der Vertraulichkeit und zur Vermeidung der Weitergabe von Adressen oder anderen persönlichen Daten."
                  }]
                }]
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 3 },
              content: [{ type: "text", text: "2.2. Pflichten des Kunden" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "2.2.1. Zugang zum Standort: Der Kunde verschafft iSTRUCT und/oder ggf. autorisierten Partnern innerhalb des vereinbarten Zeitrahmens Zugang zu dem Ort, an dem die Produkte installiert werden sollen, um Messungen, Lieferungen und Installationen durchzuführen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "2.2.2. Überprüfung der Abnahme: Nach Abschluss der Arbeiten oder nach Lieferung der Produkte unterzeichnet der Auftraggeber das Abnahmeprotokoll, nachdem er sich vergewissert hat, dass die Produkte und/oder Dienstleistungen den vereinbarten Spezifikationen entsprechen. Falls es zu Abweichungen kommt, werden diese schriftlich festgehalten und iSTRUCT ergreift die vertraglich vereinbarten Abhilfemaßnahmen."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "3. GEISTIGES EIGENTUM" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "3.1. Jegliche Dokumentation, Leitfaden, technisches Handbuch, technische Information und jegliches Know-how, die von iSTRUCT vor oder während der Ausführung des Vertrags zur Verfügung gestellt werden, bleiben das ausschließliche Eigentum von iSTRUCT. Der Kunde darf diese Materialien nicht für andere Zwecke als zur Erfüllung der vertraglichen Verpflichtungen verwenden."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "3.2. Der Kunde erwirbt keine geistigen Eigentumsrechte an Marken, Handelsnamen oder anderen ähnlichen Rechten, die iSTRUCT gehören."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "3.3. Der Zaun wird mit einer Plakette versehen, die das Emblem des Herstellers trägt. Diese Plakette wird an einem der gelieferten Zauntore angebracht. Die Anbringung erfolgt standardmäßig am Fußgängertor; sofern ein solches nicht vorhanden ist, behält sich der Hersteller das Recht vor, die Plakette an einem anderen Tor oder Zaunelement nach eigenem Ermessen anzubringen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "3.4. Klausel zur Verwendung von Bildern zu Werbezwecken"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Der Kunde erklärt sich damit einverstanden, dass iSTRUCT nach Abschluss der Arbeiten Fotos des fertiggestellten Projekts (z.B. Zäune, Tore, Einfriedungen etc.) an der vom Kunden angegebenen Adresse anfertigt, sofern diese keine erkennbaren Personen, Kfz-Kennzeichen, Hausnummern, Namen oder andere identifizierbare Daten enthalten."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Die aufgenommenen Bilder dürfen von iSTRUCT zu Werbezwecken verwendet werden, insbesondere, aber nicht ausschließlich, auf der Firmenwebsite, in sozialen Netzwerken, in Broschüren, Präsentationen und Referenzportfolios."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Der Kunde versteht, dass die Bilder ausschließlich zu den oben genannten Zwecken verwendet werden und hat das Recht, ihre Entfernung jederzeit durch schriftliche Mitteilung zu verlangen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Zur allgemeinen Ortsangabe: Das Unternehmen darf den allgemeinen Standort des Projekts (z.B. Stadt oder Region) angeben, jedoch ohne die genaue Adresse offenzulegen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [
                {
                type: "text",
                text: "⬜"
                },
                {
                type: "text",
                text: "  Durch Ankreuzen dieses Kästchens erklärt sich der Kunde mit dieser Klausel einverstanden."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "4. LIEFER- UND MONTAGEFRISTEN" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `4.1. Lieferfrist: iSTRUCT verpflichtet sich, die Produkte innerhalb von ${this.contract.t_executie} Kalendertage nach Erfüllung der folgenden Bedingungen an die vom Kunden angegebene Adresse zu liefern (oder ihre Lieferung zu gewährleisten):`
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Zahlung der Anzahlung durch den Kunden (gemäß Art. 5.1 unten);"
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Bestätigung aller notwendigen technischen Details und Messungen."
                  }]
                }]
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "4.2. Frist für die Installation: Die Montage- und Installationsdauer wird von den Parteien in Abhängigkeit von der Komplexität der Arbeiten und der Verfügbarkeit von iSTRUCT oder den von iSTRUCT beauftragten Partnern einvernehmlich festgelegt. In der Regel beträgt die Installationszeit nicht länger als 30 Arbeitstage von:"
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Der Bestätigung und Validierung aller technischen Details;"
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Der Sicherstellung des Zugangs zum Standort durch den Kunden;"
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Der Bereitstellung von Produkten und/oder zusätzlich benötigten Materialien."
                  }]
                }]
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Die voraussichtlichen Fristen und Zeitpläne werden schriftlich mitgeteilt (per E-Mail, Nachricht, Bestellung usw.). Jede wesentliche Änderung dieses Zeitrahmens aus Gründen, die dem Kunden zuzuschreiben sind oder aufgrund höherer Gewalt, wird von den Parteien mitgeteilt und im Hinblick auf eine Neuplanung erörtert."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "4.3. Bei Verzögerungen, die durch äußere Faktoren verursacht werden (Unzugänglichkeit des Standorts, ungünstige Witterungsbedingungen, Nichtkonformität der vom Kunden bereitgestellten Infrastruktur, höhere Gewalt usw.), vereinbaren die Parteien einen neuen Termin für die Lieferung/Installation."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "4.4. Übertragung des Eigentums:"
              }]
            },
            { type: "orderedList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "1. Das Eigentum an den Produkten, die Gegenstand dieses Vertrages sind, geht erst dann auf den Kunden über, wenn dieser alle Zahlungsverpflichtungen gegenüber iSTRUCT vollständig beglichen hat (u.a. den Preis der Produkte, die Lieferkosten, die Installation usw., soweit zutreffend)."
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "2. Bis zur vollständigen Bezahlung bleiben die Produkte Eigentum von iSTRUCT, auch wenn die Lieferung erfolgt ist und/oder sich die Produkte im physischen Besitz des Kunden befinden."
                  }]
                }]
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "5. PREIS UND ZAHLUNGSBEDINGUNGEN" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "5.1. Gesamtpreis"
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: this.price
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Der Gesamtpreis umfasst alle bekannten und vereinbarten Kosten, sofern nicht nachträglich Änderungen der Anforderungen des Kunden auftreten, die zusätzliche Kosten verursachen. Jede Änderung der Kosten bedarf der Schriftform und ist von beiden Parteien zu unterzeichnen."
                  }]
                }]
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "5.2. Anzahlung und Schlusszahlung"
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: this.payment1
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: this.payment2
                  }]
                }]
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "5.3. ZAHLUNG Zahlungen in EUR sind auf folgendes Bankkonto zu leisten: CUPROLLI MANUFACTURING SRL, IBAN: RO89BTRLEURCRT0337578301 ,BIC: BTRLRO22, Bankname: Banca Transilvania."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "5.4. Verzugszinsen und Mahnkosten:"
              }]
            },
            { type: "bulletList", content: [
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Gerät der Kunde mit einer fälligen Zahlung in Verzug, ist iSTRUCT berechtigt, Verzugszinsen in Höhe von 0,03 % pro Kalendertag (dies entspricht 10,95 % p.a.) des jeweils ausstehenden Betrages zu berechnen. Die Verzugszinsen werden als einfache Zinsen berechnet und sind bis zum vollständigen Zahlungseingang geschuldet."
                  }]
                }]
              },
              {
                type: "listItem",
                content: [{
                  type: "paragraph",
                  attrs: { textAlign: "left" },
                  content: [{
                    type: "text",
                    text: "Für Mahnungen, die im Abstand von mindestens 14 Tagen versendet werden, ist der Kunde verpflichtet, pauschalierte Mahnspesen in Höhe von € 15,00 (für die 1. Mahnung) bzw. € 25,00 (für die 2. Mahnung) zu ersetzen. Weitergehende gesetzliche Ansprüche auf Ersatz notwendiger Kosten zweckentsprechender Rechtsverfolgung (z.B. Inkassobüro oder Anwalt) bleiben unberührt."
                  }]
                }]
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "6. HAFTUNG" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "6.1. Haftungsausschluss: iSTRUCT haftet nicht für:"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "a) Schäden, die an den Bausätzen oder anderen Gütern durch Fehler oder Nachlässigkeit des Auftraggebers bei der Handhabung nach der Installation entstehen;"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "b) Verzögerungen oder Nichterfüllung aufgrund höherer Gewalt oder unvorhersehbarer Ereignisse;"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "c) Schäden an der Infrastruktur, den Stromnetzen oder anderen Komponenten, die nicht in der Verantwortung von iSTRUCT liegen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "6.2 Haftungsbeschränkung: Die Haftung von iSTRUCT gegenüber dem Auftraggeber für Schäden, die sich aus oder im Zusammenhang mit diesem Vertrag ergeben, ist auf den Wert der vereinbarten und tatsächlich von iSTRUCT erbrachten und von iSTRUCT anerkannten Leistungen beschränkt."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "6.3 Produktgarantie: Die Garantie für die von iSTRUCT gelieferten Produkte wird gemäß der anwendbaren nationalen Gesetzgebung (Verbraucherschutzgesetz, Regierungsverordnung Nr. 21/1992, Gesetz 449/2003 usw.) sowie der anwendbaren Rechtsvorschriften der Europäischen Union gewährt."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "6.4. Abhilfe: iSTRUCT ist verpflichtet, innerhalb von höchstens 30 Arbeitstagen ab dem Datum der Übernahme der für den Einsatz erforderlichen Elemente Abhilfe zu schaffen, wobei diese Kosten zu Lasten von iSTRUCT gehen und in Anhang 1 aufgeführt sind."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "6.5. Service und Interventionen Im Falle von Mängeln, die unter die Garantie fallen, verpflichtet sich iSTRUCT, die Kosten für die Reparatur oder den Ersatz gemäß den internen Verfahren und gesetzlichen Bestimmungen zu übernehmen. Wenn der Mangel durch den Kunden verursacht wurde (unsachgemäße Verwendung, vorsätzliche Beschädigung, Ereignisse außerhalb der angebotenen Garantie), gehen die Reparaturkosten zu Lasten des Kunden."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "7. VERTRAULICHKEIT" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "7.1. Die Vertragsparteien verpflichten sich, alle im Rahmen der Vertragserfüllung erlangten geschäftlichen, technischen oder sonstigen Informationen vertraulich zu behandeln und sie nicht ohne vorherige schriftliche Zustimmung der anderen Vertragspartei an Dritte weiterzugeben."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "7.2. Die Vertraulichkeitsverpflichtung gilt für die gesamte Laufzeit des Vertrags und für einen Zeitraum von 3 (drei) Jahren nach dessen Beendigung, sofern nicht gesetzlich etwas anderes vorgesehen ist oder schriftlich etwas anderes vereinbart wurde."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "8. PERSONENBEZOGENE DATEN UND SICHERHEIT" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "8.1. Verarbeitung personenbezogener Daten: Die Parteien halten sich an die in Rumänien und in der Europäischen Union geltenden Rechtsvorschriften zum Schutz personenbezogener Daten (einschließlich DSGVO);"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Soweit im Rahmen der Vertragsdurchführung eine Übermittlung personenbezogener Daten erfolgt, garantieren die Parteien, dass die Verarbeitung dieser Daten im Einklang mit den geltenden rechtlichen Anforderungen erfolgt."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "8.2. Sicherheit: Die Vertragsparteien verpflichten sich, die erforderlichen technischen und organisatorischen Maßnahmen zu treffen, um die Sicherheit und Vertraulichkeit der Daten zu gewährleisten;"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Jede Sicherheitsverletzung oder jeder Vorfall, der personenbezogene Daten betrifft, wird der anderen Vertragspartei gemäß den geltenden rechtlichen Verfahren unverzüglich mitgeteilt."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "9. HÖHERE GEWALT UND ZUFÄLLIGE EREIGNISSE" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "9.1. Höhere Gewalt und zufällige Ereignisse, wie sie im Gesetz definiert sind, befreien die Vertragspartei, die sich darauf beruft, für den Zeitraum, in dem sie in Kraft sind, von der Haftung, wenn sie der anderen Vertragspartei innerhalb der gesetzlich vorgesehenen Frist mitgeteilt wurden."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "9.2. Dauert das Ereignis höherer Gewalt oder das unvorhersehbare Ereignis länger als 30 (dreißig) aufeinanderfolgende Tage an, so kann jede Vertragspartei beschließen, den Vertrag zu kündigen, ohne weitere Schadensersatzansprüche zu stellen."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "10. LAUFZEIT UND BEENDIGUNG" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "10.1. Laufzeit: Dieser Vertrag tritt am Tag seiner Unterzeichnung durch beide Parteien in Kraft und bleibt bis zur Erfüllung aller Verpflichtungen (Lieferung, Zahlung, Garantie) gültig."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "10.2. Vorzeitige Kündigung: Jede Vertragspartei kann diesen Vertrag einseitig unter Einhaltung einer Frist von mindestens 15 (fünfzehn) Tagen schriftlich kündigen. Wenn der Kunde den Vertrag einseitig kündigen möchte, gelten folgende Regeln:"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "10.2.1 Wenn eine Anzahlung geleistet wurde:"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "iSTRUCT ist berechtigt, diese Anzahlung ganz oder teilweise als Entschädigung einzubehalten, soweit bereits Aufträge für Material, Sonderanfertigungen (einschließlich Sonderfarben) oder andere unmittelbar mit der Herstellung und/oder Lieferung der Produkte zusammenhängende Ausgaben erteilt wurden."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Der nicht in Anspruch genommene Teil der Anzahlung (falls vorhanden) kann dem Auftraggeber entsprechend den Belegen über die bereits entstandenen Kosten zurückerstattet werden."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "10.2.2 Wenn keine Anzahlung geleistet wurde:"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "Der Auftraggeber kann den Vertrag nicht einseitig kündigen, ohne den Gegenwert der von iSTRUCT bereits getätigten Ausgaben für die Ausführung des Auftrags (z.B. Einkauf von Material oder Arbeitskräften für Sonderanfertigungen) zu zahlen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "iSTRUCT ist berechtigt, den durch die einseitige Kündigung des Vertrags erlittenen Schaden zu ersetzen, einschließlich des Wertes der bereits gekauften oder angepassten Materialien."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "In jedem Fall vereinbaren die Parteien einvernehmlich die Art und Weise der Rückerstattung oder Entschädigung der bereits entstandenen Kosten, unbeschadet des Rechts von iSTRUCT, zusätzlichen Schadenersatz zu fordern, wenn dieser nach dem Gesetz gerechtfertigt werden kann."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "10.3. Kündigung aufgrund von Nichterfüllung: Kommt eine der Vertragsparteien ihren Verpflichtungen nicht nach und wird diese Nichterfüllung nicht innerhalb von 5 (fünf) Tagen nach Erhalt einer schriftlichen Ermahnung behoben, kann die andere Partei ohne weitere Formalitäten den Vertrag fristlos kündigen."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "11. ANWENDBARES RECHT UND GERICHTSBARKEIT" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "11.1. Außergerichtlicher Vergleich: Die Vertragsparteien bemühen sich um eine gütliche Beilegung von Meinungsverschiedenheiten, die sich aus diesem Vertrag ergeben oder damit zusammenhängen. Kann der Streit nicht innerhalb von 15 (fünfzehn) Tagen nach Beginn der Verhandlungen gütlich beigelegt werden, kann sich die betroffene Partei an das zuständige Gericht wenden."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "11.2. Anwendbares Recht. Gerichtsstand: Der vorliegende Vertrag unterliegt dem rumänischen Recht, insbesondere dem Zivilgesetzbuch und dem geltenden Steuerrecht. Alle Streitigkeiten, die sich aus oder im Zusammenhang mit diesem Vertrag ergeben, werden von den zuständigen rumänischen Gerichten im Umkreis des Geschäftssitzes von iSTRUCT gelöst, sofern die Parteien nichts anderes vereinbaren."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "heading",
              attrs: { textAlign: "left", level: 2 },
              content: [{ type: "text", text: "12. SCHLUSSBESTIMMUNGEN" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "12.1. Abtretung: Der Auftraggeber darf diesen Vertrag oder die sich daraus ergebenden Rechte und Pflichten ohne vorherige schriftliche Zustimmung von iSTRUCT weder ganz noch teilweise abtreten. iSTRUCT kann seine Rechte und Pflichten nach Mitteilung an den Auftraggeber frei an Dritte übertragen."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "12.2. Zustimmung zur Datennutzung: Der Kunde erklärt sich ausdrücklich damit einverstanden, dass iSTRUCT die für die Ausführung und Überwachung dieses Vertrags erforderlichen Daten (auch für buchhalterische und steuerliche Zwecke) unter Einhaltung der Rechtsvorschriften über den Schutz personenbezogener Daten verwendet und verarbeitet."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "12.3. Mitteilungen: Alle Mitteilungen, Ersuchen und Kommunikation zwischen den Vertragsparteien sind schriftlich (auch per E-Mail mit Empfangsbestätigung) zu übermitteln und gelten an dem Tag des Eingangs oder der elektronischen Empfangsbestätigung als wirksam abgegeben."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "(Hinweis: Die Parteien können je nach ihren Präferenzen weitere Zustellungsarten vereinbaren)."
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: "12.4. Verzicht: Die Nichtausübung oder verspätete Ausübung eines in diesem Vertrag vorgesehenen Rechts durch eine der Vertragsparteien stellt keinen Verzicht auf dieses Recht dar. Auf ein Recht kann nur schriftlich verzichtet werden."
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            // Contract conclusion
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                text: `Dieser Vertrag wurde heute _____________________ in 2 (zwei) Originalausfertigungen, eine für jede Partei, unterzeichnet.`
              }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },

            // Signatures
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{
                type: "text",
                marks: [{ type: "bold" }],
                text: "CUPROLLI MANUFACTURING SRL (iSTRUCT)"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{ type: "text", text: "Gesetzlicher Vertreter: " }, { type: "text", marks: [{ type: "bold" }], text: "Octavian Rosu" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{ type: "text", text: "Position: " }, { type: "text", marks: [{ type: "bold" }], text: "Geschäftsführer" }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "left" },
              content: [{ type: "text", text: "Unterschrift und Stempel:" }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
            {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{
                type: "text",
                marks: [{ type: "bold" }],
                text: "KUNDE"
              }]
            },
            {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{ type: "text", text: this.contract.nume.toUpperCase() }]
            },
            this.contract.persoana ? {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{ type: "text", text: this.contract.persoana }]
            } : { type: "blockquote" },
            {
              type: "paragraph",
              attrs: { textAlign: "right" },
              content: [{ type: "text", text: "Unterschrift:" }]
            },
            { type: "paragraph", attrs: { textAlign: "left" } },
          ]
        }
      },

      // PDF Generation
      async generatePdf(documentText) {
        const doc = await pdf_contract.createContractPDF(documentText.content, contract.country, CONTRACT_FORM_CODE)
        return doc
      }
    }
  }
}